import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-auction-type-info-dialog',
  templateUrl: './auction-type-info-dialog.component.html',
  styleUrls: ['./auction-type-info-dialog.component.scss']
})
export class AuctionTypeInfoDialogComponent implements OnInit {
  @Input() isMemorabid: boolean;
  @Input() inPreEventStatus: boolean; // true se isPreEvent == true ed eventIsOpen == false

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
